import script from "./ClassNumberChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassNumberChart.vue?vue&type=script&setup=true&lang=js"

import "./ClassNumberChart.vue?vue&type=style&index=0&id=1387509a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1387509a"]])

export default __exports__